import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  getAdditionalUserInfo,
} from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { createEmployee } from "./employee";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  // storageBucket: "influxeradmin.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// export const db = initializeFirestore(app, { cacheSizeBytes: 1048576 });

const provider = new GoogleAuthProvider();

export const signInWithEmailPass = async (username, password) => {
  try {
    const userLogin = await signInWithEmailAndPassword(
      auth,
      username,
      password
    );
    if (userLogin) {
      return userLogin;
    } else {
      return false;
    }
  } catch (error) {
    return { error: true, message: "Incorrect username or password" };
  }
};

export const forgotPassword = async (username) => {
  try {
    await sendPasswordResetEmail(auth, username);
    return { message: "Password reset email sent. Please check your email." };
  } catch (error) {
    console.log(error.message);
    return { error: true, message: "Unable to send password reset email" };
  }
};

export const signInWithGoogle = async () => {
  const userLogin = await signInWithPopup(auth, provider);
  console.log("logged in with popup", userLogin);
  if (userLogin) {
    const domain = userLogin.user.email?.split("@")[1];
    console.log(domain);

    if (domain !== "influxer.com") {
      await auth.signOut();
      await auth.updateCurrentUser(null);
      return { error: "Not influxer account" };
    }

    return userLogin;
  } else {
    return false;
  }
};

const createNewEmployee = async (userLogin) => {
  await createEmployee(userLogin);
};

export const getToken = async (user) => {
  const access_token = await auth.currentUser.getIdToken(true);
  if (access_token) {
    console.log("success", access_token);
  } else {
    console.log("error", access_token);
  }
};

export const signOutWithGoogle = async () => {
  await auth.signOut();
};
